import {createFileRoute} from '@tanstack/react-router';
import {StatementPaymentPage} from 'features/statement-payment/pages/StatementPaymentPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/_payment/',
)({
  component: StatementPaymentPage,
});
